import styled, { css } from "styled-components";
const ContentArea = styled.div(
  ({ $isSecurityPerspective, theme }) => css`
    display: flex;
    flex-direction: column;
    padding-left: 0;
    padding-top: ${$isSecurityPerspective ? "0px" : "15px"};
    transition: all 0.33s ease-in-out;
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    z-index: 10;
    top: 0;
    background: ${theme.colors.global.background};
  `
);
export default ContentArea;
